import React from 'react'
import styled from '@emotion/styled'
import TemplateList from '../shared/templates/template-list'
import GroupDropdown from './group-dropdown'
import SubgroupMenu from './subgroup-menu'
import useGalleryTheme from './hooks/use-gallery-theme'

const Container = styled.div``

const Menu = styled(SubgroupMenu)`
  background: ${p => p.theme.colors.white};
  box-shadow: ${p => p.theme.shadows.default};
  min-width: 18.5rem;
`

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 ${p => p.theme.space[8]};
  min-height: 3rem;
`

const Title = styled.span`
  :hover {
    text-decoration: underline;
  }
`

const Sup = styled.sup`
  font-size: ${p => p.theme.fontSizes[1]};
  vertical-align: super;
`

const Group = ({ group, subgroup, templates, ...rest }) => {
  const { theme } = useGalleryTheme()
  return (
    <Container {...rest}>
      {subgroup && (
        <Header>
          <GroupDropdown render={() => <Menu group={group} />}>
            <Title>{subgroup && subgroup.name}</Title>
            <Sup>({(subgroup || group).templateCount})</Sup>
          </GroupDropdown>
        </Header>
      )}
      <TemplateList templates={templates} defaultTheme={theme} />
    </Container>
  )
}

export default Group
